<template>
    <div>
        <client-only>
            <template v-if="navigatorShare">
                <b-button variant="link" @click="share">
                    <svg width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                    </svg>
                </b-button>
            </template>
            <template v-else>
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret right>
                    <template #button-content>
                        <svg width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                        </svg>
                    </template>
                    <b-dropdown-item v-for="(item, index) in networks" :key="index" :href="item.link" target="_blank" :title="item.title" :data-action="item.action">
                        <div class="d-flex align-items-center">
                            <img :src="item.icon" :alt="item.title" :title="item.title" width="16" height="16" class="mr-2">
                            {{ item.title }}
                        </div>
                    </b-dropdown-item>
                </b-dropdown>
            </template>
        </client-only>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                default: ''
            },
            text: {
                default: ''
            },
            url: {
                default: ''
            }
        },
        computed: {
            navigatorShare() {
                return typeof navigator === 'object' && typeof navigator.share === 'function'
            },
            networks() {
                return [
                    {
                        link: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.urlShare),
                        title: 'Compartilhar no Facebook',
                        icon: '/img/share/facebook.svg',
                        action: 'share/facebook/share'
                    },
                    {
                        link: 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.title + ' - ' + this.urlShare),
                        title: 'Compartilhar no Twitter',
                        icon: '/img/share/twitter.svg',
                        action: ''
                    },
                    {
                        link: 'https://api.whatsapp.com/send?text=' + encodeURIComponent(this.title + ' - ' + this.urlShare),
                        title: 'Compartilhar no WhatsApp',
                        icon: '/img/share/whatsapp.svg',
                        action: 'share/whatsapp/share'
                    }
                ]
            },
            urlShare() {
                return /^(http|https):\/\//.test(this.url) ? this.url : this.$host + this.url
            }
        },
        methods: {
            async share() {
                try {
                    await navigator.share({
                        title: this.title,
                        text: this.text,
                        url: this.url,
                    })
                        .catch((error) => {
                            console.log('Error sharing', error)
                        });
                } catch (err) {
                    console.error(err)
                }
            }
        }
    }
</script>
